export const FAQState = {
    errorCode : 0,
    statusCode : 0,
    FAQList : [],
    message : '',
    isLoading : false
}